import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { SpecialtyViewModel } from '../../../models/Entities/Specialties/SpecialtyModels';
import * as SpecialtiesStore from '../../../redux/middleware/Specialties.Middleware';

//#region Props

export interface IProps {
  searchCriteria?: string;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  isDeleting: boolean | undefined;
  isDeletedSuccessfully: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  specialties: SpecialtyViewModel[];
}

interface DispatchProps {
  GetAllSpecialties: typeof SpecialtiesStore.actionCreators.GetAllSpecialties;
  DeleteSpecialty: typeof SpecialtiesStore.actionCreators.DeleteSpecialty;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.Specialties?.isLoadingAll,
  isLoadingSuccessfully: state.Specialties?.successLoadingAll,
  isDeleting: state.Specialties?.isDeletingOne,
  isDeletedSuccessfully: state.Specialties?.successDeletingOne,
  failOnDeleting: state.Specialties?.failOnDeletingOne,
  error: state.Specialties?.error,
  specialties: state.Specialties?.list ?? [],
  ...ownProps
});

export const mapDispatchToProps = {
  ...SpecialtiesStore.actionCreators
};

//#endregion Props
